import { useEffect, useState } from 'react';
import { Skeleton, useStateInRef } from 'seagull';
import { modifyLoomPlayerStyles } from "./LoomPlayer.utils";
import { VideoPlayerErrors, VideoPlayerStatus } from "../VideoPlayer";
import { useIoContext } from "../../../contexts";
import styles from "./LoomPlayer.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LoomPlayer = props => {
  const {
    url,
    width
  } = props;
  const getProps = useStateInRef(props);
  const {
    loomParser
  } = useIoContext();
  const [html, setHtml] = useState();
  useEffect(() => {
    const {
      onReady,
      onError
    } = getProps();
    (async () => {
      try {
        const {
          title: videoName,
          html
        } = await loomParser(url);
        setHtml(modifyLoomPlayerStyles(html));
        onReady === null || onReady === void 0 || onReady({
          videoName
        });
      } catch (error) {
        onError === null || onError === void 0 || onError({
          message: VideoPlayerErrors[VideoPlayerStatus.NOT_FOUND]
        });
      }
    })();
  }, [url]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.loomContainer,
    children: [/*#__PURE__*/_jsx(Skeleton, {
      height: "100%",
      width: "100%"
    }), /*#__PURE__*/_jsx("div", {
      style: {
        width
      },
      className: styles.loomPlayer,
      dangerouslySetInnerHTML: html ? {
        __html: html
      } : undefined,
      "data-testid": "loom-player"
    })]
  });
};
export default LoomPlayer;